import React, { useEffect, useState } from "react";
import "./style.css";
import axios from "axios";
import SliderHP from "./slider-hp";

import TehranUniLogo from "../../../assets/tehranUni-logo.png";
import HayatLogo from "../../../assets/hayat-logo.png";
import LoginPagePicture from "../../../assets/hp-test-image.png";
import AvatLogo from "../../../assets/Avat.png";
import KhaneKheradLogo from "../../../assets/khenehkherad-sh-logo.png";
import EvaluationsImage from "../../../assets/Evaluations-Product.png";
import DigitalFilesImage from "../../../assets/DigitalFiles-Product.png";
import HeaderFa from "../header-fa";

import {
  BiTargetLock,
  BiHourglass,
  BiMobileAlt,
  BiMoney,
  BiClinic,
  BiUser,
} from "react-icons/bi";
import {
  IoFileTrayFullOutline,
  IoGameControllerOutline,
} from "react-icons/io5";
import { BsCardChecklist } from "react-icons/bs";
import { HiOutlineUserGroup } from "react-icons/hi";
import FooterFa from "../footer-fa";

const faNumbers = require("../../../utils/numbersFa.js");

const engText = require("../../../utils/homepageEnglishTexts.js");
const faText = require("../../../utils/homepageFarsiTexts.js");

class HomePage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      homepageText: "",
      countryCode: this.props.languageInput,
      sendMessage: "Hello,I'mInHomePage",
      testsCount: 0,
      gamesCount: 0,
      clinicsCount: 0,
    };
  }

  componentDidMount = async () => {
    this.handleRedirect();
    const lang = localStorage.getItem("lang");
    if (lang == null) {
      if (this.state.countryCode == "IR") {
        this.setState({ homepageText: [...faText] });
      } else {
        this.setState({ homepageText: [...engText] });
      }
    } else if (lang == "IR") {
      this.setState({ homepageText: [...faText] });
      this.setState({ countryCode: "IR" });
    } else {
      this.setState({ homepageText: [...engText] });
      this.setState({ countryCode: "US" });
    }
  };

  componentDidUpdate = () => {
    if (this.props.languageInput != this.state.countryCode) {
      this.setState({ countryCode: this.props.languageInput });
      if (this.props.languageInput == "IR") {
        this.setState({ homepageText: [...faText] });
      } else {
        this.setState({ homepageText: [...engText] });
      }
    }
  };

  async handleRedirect() {
    const response = await axios.post("https://request.kidiar.com/pages/request", {
      sendMe: this.state.sendMessage,
    });
    this.setState({ testsCount: response.data.tests });
    this.setState({ gamesCount: response.data.games });
    this.setState({ clinicsCount: response.data.clinics });
  }

  render() {
    return (
      <div className="homepage">
        <HeaderFa />
        <SliderHP />

        <div className="landing-description mt-5 mb-3 align-items-center mode-bg-9">
          <div className="d-flex flex-column justify-content-center align-items-center align-text-center w-80">
            <h2>{"چرا غربالگری اتیسم با هوش مصنوعی؟"}</h2>
            <p>
              {
                "ابزار فوق‌العاده‌ی غربالگری اتیسم با هوش مصنوعی یک ارزیابی سریع و دقیق از کودک شما انجام می‌دهد که حتی می‌تواند در احتمال وجود اتیس در کودک ۱۸ ماهه هم به شما کمک کند. این ابزار رایگان، کاربر پسند و قابل دسترسی در موبایل می‌باشد. کافی است ۵ دقیقه از زمان خود را برای اطمینان از آینده‌ای مطمئن برای کودک خود صرف کنید"
              }
            </p>
          </div>

          <div className="landing-description-body">
            <div className="landing-description-body-row">
              <div className="landing-description-body-row-section">
                <div className="w-20 font-64">
                  <BiTargetLock />
                </div>
                <div className="d-flex flex-column w-80">
                  <h3>{"دقت بالا"}</h3>
                  <p>
                    {
                      "پرسشنامه‌ی غربالگری اتیسم مهروبو با صدها داده‌ی واقعی از کودکان زیر ۷ سال - شامل دارای اتیسم و بدون اختلال اتیسم - با بهره‌گیری از هوش مصنوعی آموزش داده شده است. این ابزار یکی از دقیق‌ترین ابزارهای غربالگری و کمک به تشخیص اتیسم تا به امروز می‌باشد که می‌تواند به شما جهت تشخیص زودهنگام اتیسم کمک کند"
                    }
                  </p>
                </div>
              </div>
              <div className="landing-description-body-row-section">
                <div className="w-20 font-64">
                  <BiHourglass />
                </div>
                <div className="d-flex flex-column w-80">
                  <h3>{"تشخیص زودهنگام"}</h3>
                  <p>
                    {
                      "تشخیص اتیسم قبل از ۳ سالگی یک فرصت طلایی جهت جلوگیری از آثار آن در آینده‌ی کودک است. ابزار رایگان و کاربرپسند ما خانواده‌های دغدغه‌مند را قادر می‌سازد تا اقداماتی در زمان مناسب جهت جلوگیری از عواقب اختلال اتیسم در زندگی فرد انجام دهند. با کمک این ابزار در موبایلتان، دیگر استرس رفتن به کلینیک جهت بررسی کودک و دریافت جواب از متخصص را نخواهید داشت و در خلوت خود می‌توانید غربالگری اتیسم را انجام داده و نتیجه را همان لحظه مشاهده کنید"
                    }
                  </p>
                </div>
              </div>
            </div>
            <div className="landing-description-body-row">
              <div className="landing-description-body-row-section">
                <div className="w-20 font-64">
                  <BiMobileAlt />
                </div>
                <div className="d-flex flex-column w-80">
                  <h3>{"استفاده آسان"}</h3>
                  <p>
                    {
                      "این ابزار برای راحتی شما طراحی شده است. خیلی راحت می‌توانید در موبایل خود و بدون قضاوت اطرافیان، رشد کودک خود را بررسی کنید و از روند نرمال آن اطمینان حاصل کنید. شما مجبور به پرداخت هیچ گونه هزینه‌ای جهت این ابزار دقیق نخواهید بود و بدون دغدغه می‌توانید از روند رشد کودک خود اطمینان حاصل کنید"
                    }
                  </p>
                </div>
              </div>
              <div className="landing-description-body-row-section">
                <div className="w-20 font-64">
                  <BiMoney />
                </div>
                <div className="d-flex flex-column w-80">
                  <h3>{"پرداخت اختیاری"}</h3>
                  <p>
                    {
                      "غربالگری با هوش مصنوعی مهروبو نیاز به هیچ گونه پرداختی ندارد و شما تنها در صورت علاقه، می‌توانید با پرداخت اختیاری از ما حمایت کنید تا بتوانیم به راه خود در کمک به تشخیص و آگاه سازی در زمینه اتیسم ادامه دهیم. سلامت کودک شما اولویت اصلی مهروبو می‌باشد و ما دوست نداریم هیچ خانواده‌ای به دلیل مشکلات مالی از تشخیص یا درمان اتیسم عقب بماند و سال‌های طلایی درمان این اختلال را از دست بدهد"
                    }
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="products-hp">
          <div className="product-hp-container">
            <div
              className="product-hp-content"
              style={{ width: "100%", marginRight: 0 }}
            >
              <h1>{"تست هوشمند اتیسم"}</h1>
              <p>
                {
                  "تست غربالگری اتیسم با استفاده از هوش مصنوعی ابزاری قدرتمند را در اختیار مادران و متخصصین قرار می‌دهد تا بتوانند تنها در چند ثانیه امکان وجود اتیسم در کودک را بررسی نموده و در صورت نیاز جهت تشخیص اتیسم یا سایر اقدامات به کلینیک مراجعه کنند"
                }
              </p>
            </div>
            <div className="product-hp-image">
              <img src={EvaluationsImage}></img>
            </div>
          </div>
          <div className="product-hp-container" style={{ direction: "ltr" }}>
            <div className="product-hp-content" style={{ direction: "rtl" }}>
              <h1>{"بازی شناختی موزیکوبو"}</h1>
              <p>
                {
                  "بازی شناختی موزیکوبو یک بازی شناختی بر پایه‌ی موسیقی درمانی می‌باشد که در موبایل یا تبلت کودک خود می‌توان آن را نصب نموده و به تقویت مهارت‌های شنیداری کودک در قالب یک بازی موبایلی بپردازید"
                }
              </p>
            </div>
            <div
              className="product-hp-image"
              style={{ borderRadius: "50px 0 0 50px" }}
            >
              <img src={DigitalFilesImage}></img>
            </div>
          </div>
        </div>

        <div className="statics" style={{ flexDirection: "column" }}>
          <h1>{"اعتماد شما باعث افتخار ماست"}</h1>
          <div className="statics-container statistics-bottom">
            <div className="statics-card">
              <div className="stats-square middle">
                <IoFileTrayFullOutline></IoFileTrayFullOutline>
                <p style={{ marginTop: 0, marginBottom: 0 }}>
                  {faNumbers[this.state.testsCount - 400]}
                </p>
                <p style={{ marginTop: 0, marginBottom: 0 }}>
                  {"تست‌های انجام شده"}
                </p>
              </div>
            </div>
            <div className="statics-card">
              <div className="stats-square">
                <IoGameControllerOutline></IoGameControllerOutline>
                <p style={{ marginTop: 0, marginBottom: 0 }}>
                  {faNumbers[this.state.gamesCount - 40]}
                </p>
                <p style={{ marginTop: 0, marginBottom: 0 }}>{"دانلود بازی"}</p>
              </div>
            </div>
          </div>
        </div>

        <FooterFa />
      </div>
    );
  }
}

export default HomePage;
